import {Injectable, inject, TemplateRef, ViewContainerRef} from '@angular/core';
import {Overlay, OverlayRef, ConnectedPosition, OverlayConfig} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';

export interface OverlayOptions {
  origin: HTMLElement;
  hasBackdrop?: boolean;
  backdropClass?: string;
  positions?: ConnectedPosition[];
  width?: string | number;
  minWidth?: string | number;
  maxHeight?: string | number;
}

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private readonly overlay = inject(Overlay);

  createOverlay(template: TemplateRef<any>, options: OverlayOptions, viewContainerRef: ViewContainerRef): OverlayRef {
    const defaultPositions: ConnectedPosition[] = [
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: -1
      },
      {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: 1
      }
    ];

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(options.origin)
      .withPositions(options.positions || defaultPositions)
      .withPush(false);

    const config: OverlayConfig = {
      positionStrategy,
      hasBackdrop: options.hasBackdrop ?? false,
      backdropClass: options.backdropClass || 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      width: options.width,
      minWidth: options.minWidth || options.width,
      maxHeight: options.maxHeight
    };

    const overlayRef = this.overlay.create(config);
    const portal = new TemplatePortal(template, viewContainerRef);
    overlayRef.attach(portal);

    return overlayRef;
  }
}
